import Raven from 'raven-js';
import { Alert } from 'foundations-components/transitional/components/Alert';
import { jsx as _jsx } from "react/jsx-runtime";
const ErrorAlert = ({
  errorMessage,
  error
}) => {
  Raven.captureException(error);
  return /*#__PURE__*/_jsx(Alert, {
    type: "danger",
    children: errorMessage
  });
};
export default ErrorAlert;